
<!--  -->
<template>
  <div class="content">
    <div class="fot">
      <!-- 表单部分 -->
      <div class="form_fot" v-if="index == 1">
        <span></span>
        <div class="title">
          <!-- {{ text_session }} -->
          {{ text ? text_session : text }}
        </div>
        <div class="text">
          {{
            top_text 
              ? top_session
              : top_text
          }}
        </div>
        <div class="flex_input">
          <div class="li">
            <input
              type="text"
              class="input width"
              placeholder="请输入您的公司名称"
              v-model="compay_name"
            />
          </div>
          <div class="li">
            <input
              type="text"
              v-model="name"
              class="input"
              placeholder="请输入您的姓名"
            />
          </div>
          <div class="li">
            <input
              type="text"
              v-model="phone"
              class="input"
              placeholder="请输入您的联系电话"
            />
          </div>
        </div>
        <div class="bot" @click="save">免费体验</div>

        <div class="text_color">
          {{
            fot_text
              ? fot_session
              : fot_text
          }}
        </div>
      </div>
      <div class="toplg" v-if="index == 0 || index == 2">
        <img src="../assets/img/index/logo.png" alt="" />
      </div>
      <!-- 中间部分 -->
      <div class="fotcenter">
        <div class="card flex">
          <div class="li">
            <img class="phone" src="../assets/img/index/phne.png" alt="" />
            <div class="right">
              <div class="text">电话：0731-82250983</div>
              <div class="text">手机：137-0749-5921</div>
              <div class="text color">欢迎电话联系</div>
            </div>
          </div>
          <div class="li">
            <img class="addree" src="../assets/img/index/addree.png" alt="" />
            <div class="right">
              <div class="text">湖南省长沙市芙蓉区</div>
              <div class="text">芙蓉中路二段111号华菱大厦</div>
              <div class="text color">欢迎莅临本公司</div>
            </div>
          </div>
          <div class="li">
            <img class="er" src="../assets/img/index/er.png" alt="" />
            <div class="right">
              <div class="text">湖南浩通科技</div>
              <div class="text">公众号</div>
              <div class="text color">扫一扫，关注我们</div>
            </div>
          </div>
        </div>
      </div>
      <!--底部文字 -->
      <div class="fot_text">
        Copyright © 2018-{{ new Date().getFullYear() }}  hitalgroup.com Inc.All rights reserved.<a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >湘ICP备05001971号-8</a
        >版权声明
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["index", "text", "a_url", "top_text", "fot_text"],
  data() {
    //这里存放数据
    return {
      compay_name: "",
      name: "",
      phone: "",
      text_session:window.sessionStorage.getItem('text'),
      top_session:window.sessionStorage.getItem('top_text'),
      fot_session:window.sessionStorage.getItem('fot_text'),
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
 watch: {
  text() {
    this.text_session = window.sessionStorage.getItem("text") || "";
  },
  top_text() {
    this.top_session = window.sessionStorage.getItem("top_text") || "";
  },
  fot_text() {
    this.fot_session = window.sessionStorage.getItem("fot_text") || "";
  }
},
mounted() {
  window.addEventListener("sessionStorageChange", this.handleSessionStorageChange);
},

  //方法集合
  methods: {
    handleSessionStorageChange() {
    this.text_session = window.sessionStorage.getItem("text") || "";
    this.top_session = window.sessionStorage.getItem("top_text") || "";
    this.fot_session = window.sessionStorage.getItem("fot_text") || "";
  },

    save() {
      console.log(/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone));
      if (this.phone == "" || this.compay_name == "" || this.name == "") {
        alert("请输入完整信息！");
        this.$message({
          message: "请输入完整信息！",
          type: "warning",
        });
      } else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone)) {
        alert("请输入正确电话！");
        this.$message({
          message: "请输入正确电话！",
          type: "warning",
        });
      } else {
        var form = new FormData();
        form.append("name", this.name);
        form.append("company_name", this.compay_name);
        form.append("phone", this.phone);
        $.ajax({
          type: "POST", //请求的类型
          url: "http://www.hitalgroup.com/interface/message.php", //请求的路径
          data: form, //请求的参数
          async: false,
          cache: false,
          dataType: "json",
          contentType: false,
          processData: false,
          success: function (result) {
            //成功返回触发的方法
            alert(result.msg);
          },
          //请求失败触发的方法
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log("ajax请求失败");
            console.log("请求对象XMLHttpRequest: " + XMLHttpRequest);
            console.log("错误类型textStatus: " + textStatus);
            console.log("异常对象errorThrown: " + errorThrown);
          },
        });

        this.compay_name = "";
        this.name = "";
        this.phone = "";
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
 beforeDestroy() {
  window.removeEventListener(
    "sessionStorageChange",
    this.handleSessionStorageChange
  );
},
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.fot {
  background: #021e49;
  // 头部logn
  .toplg {
    padding: 45px 0;
    img {
      // width: 237px;
      // height: 66px;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
  // 电话和联系我们
  .fotcenter {
    border-top: 1px solid rgba(2, 53, 123, 0.8);
    border-bottom: 1px solid rgba(2, 53, 123, 0.8);
    padding: 26px 0;
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .li {
      display: flex;
      align-items: center;
      .phone {
        width: 40px;
        height: 39px;
      }
      .addree {
        width: 44px;
        height: 44px;
      }
      .er {
        width: 120px;
        height: 120px;
      }
      .right {
        padding-left: 28px;
        .text {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #f5f5f5;
          line-height: 24px;
        }
        .color {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #a8ceff;
          line-height: 24px;
          padding: 5px 0 0 0;
        }
      }
    }
  }
  //底部文字
  a {
    color: #f5f5f5;
  }
  .fot_text {
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #f5f5f5;
    opacity: 0.5;
    text-align: center;
    padding: 32px 0;
  }
}
// 表单
span {
  margin-left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: 0;

  height: 0;

  overflow: hidden;

  border: 30px solid transparent;

  border-top-color: #fff; //top就是倒三角，bottom就是上三角，left,right类似
}
.form_fot {
  .title {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    padding: 120px 0 20px 0;
  }
  .text {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
  }
  .flex_input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .width {
    width: 300px;
  }
  .li {
    margin: 60px 20px;
  }
  .input {
    // width: 100%;
    height: 56px;
    background: #f7f7f7;
    border-radius: 3px 3px 3px 3px;
    border: none;
    margin: 5px 0;
    padding-left: 15px;
    border-radius: 5px;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 36px;
  }
  input:focus {
    outline: none;
    border-color: #9ecaed;
    box-shadow: 0 0 10px #9ecaed;
  }
  .bot {
    width: 260px;
    height: 50px;
    background: #fe9f3a;
    border-radius: 5px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
    margin-left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .text_color {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #5d7497;
    line-height: 36px;
    text-align: center;
    padding: 32px 0 95px 0;
  }
}
</style>